export default {
    actions: {},
    mutations: {},
    state: {
        data: null,
        groups: [
            {
                'label': 'Summary',
                'icon': 'globe',
                'desc': 'In this section you will need to fill in only general information about your startup. <br/> These answers will go into the startup summary section of your report.'
            },
            {
                'label': 'Team',
                'icon': 'users',
                'active': true,
                'desc': 'Your team is one of the most significant factors in the success of your start-up and so it is an important part of your valuation.'
            },
            {
                'label': 'Market & Product',
                'icon': 'pie-chart',
                'desc': 'Tell us more about your product/service, what stage of product development you are at, and describe the market you are in.'
            },
            {
                'label': 'Business Model',
                'icon': 'building-o',
                'desc': 'Now let’s get down to the technical stuff. Answer the following questions based on where you are at now.'
            },
            {
                'label': 'IP & Legal',
                'icon': 'book',
                'desc': 'Don’t worry we’re only asking for the basics that investors need to know about!'
            },
        ]
    },
}
